import { WRAPPER } from '@/shared/styles/themes';
import styled from 'styled-components';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';

export const Wrapper = styled.div`
  ${WRAPPER};

  display: block;
  flex-direction: column;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    //padding: 0 18px;
  }

  ${({ $hasScroll }) =>
    $hasScroll &&
    `
   @media(max-width:768px) {
    margin: 0px;
      // .gameView:first-child {
      //     margin-left: 18px
      //     }
  }


  `}
`;

export const NotFound = styled.div`
  text-align: center;
  display: inline-block;
  margin: 60px;
`;

export const NotFoundTitle = styled.div`
  color: #edeff5;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  margin-bottom: 12px;
`;

export const Providers = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    display: flex;
    gap: 14px;
    scroll-behavior: smooth;
    margin: 6px 18px;
  }
`;

export const ProvidersWrapper = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: flex;
    scroll-behavior: smooth;
    overflow: scroll;
    flex-direction: column;
    margin-bottom: 60px;
    margin-bottom: 0px;
    align-items: flex-start;

    //a:first-child {
    //  margin-left: 18px
    //}
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Provider = styled.a`
  border-radius: 8px;
  background: #27262b;
  position: relative;
  padding: 0px 6px;
  background-image: ${(props) => `url(${resolveMediaPath(props.$imageUrl)})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%;
  width: 100%;
  min-height: 129px;
  cursor: pointer;
  @media (max-width: 768px) {
    min-width: 127px;
    min-height: 86px;
  }
`;

export const ProviderGamesCount = styled.div`
  position: absolute;
  color: #afafee;
  opacity: 0.5;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
  top: 8px;
  right: 8px;
`;
